var map = {
	"./rosario_fall.svg": "b24e",
	"./rosario_generica.svg": "39d3",
	"./rosario_spring.svg": "397a",
	"./rosario_summer.svg": "7399",
	"./rosario_winter.svg": "47b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca0c";